import { ReactComponent as Getuniq } from '../../images/icon-components/payment-types-logo/getuniq.svg'
import { ReactComponent as GetuniqInner } from '../../images/icon-components/payment-types-logo/getuniq-white.svg'

import { ReactComponent as Lucky } from '../../images/icon-components/payment-types-logo/lucky.svg'
import { ReactComponent as LuckyInner } from '../../images/icon-components/payment-types-logo/lucky-white.svg'

import { ReactComponent as Qiwi } from '../../images/icon-components/payment-types-logo/qiwi.svg'
import { ReactComponent as QiwiInner } from '../../images/icon-components/payment-types-logo/qiwi-white.svg'

import { ReactComponent as Card } from '../../images/icon-components/payment-types-logo/card.svg'
import { ReactComponent as CardInner } from '../../images/icon-components/payment-types-logo/card-white.svg'

import { ReactComponent as Cashless } from '../../images/icon-components/payment-types-logo/cashless.svg'
import { ReactComponent as CashlessInner } from '../../images/icon-components/payment-types-logo/cashless-white.svg'

import { ReactComponent as Admitad } from '../../images/icon-components/payment-types-logo/admitad.svg'
import { ReactComponent as AdmitadInner } from '../../images/icon-components/payment-types-logo/admitad-white.svg'

import { ReactComponent as Tinkoff } from '../../images/icon-components/payment-types-logo/tinkoff.svg'
import { ReactComponent as TinkoffInner } from '../../images/icon-components/payment-types-logo/tinkoff-white.svg'

import { ReactComponent as Adsimple } from '../../images/icon-components/payment-types-logo/adsimple.svg'

import {
  ReactComponent as Capitalist,
  ReactComponent as CapitalistInner,
} from '../../images/icon-components/payment-types-logo/capitalist-white.svg'

import {
  ReactComponent as Bitcoin,
  ReactComponent as BitcoinInner,
} from '../../images/icon-components/payment-types-logo/bitcoin.svg'

import {
  ReactComponent as UsdtErc20,
  ReactComponent as UsdtErc20Inner,
} from '../../images/icon-components/payment-types-logo/usdt-erc20.svg'

import {
  ReactComponent as UsdtTrc20,
  ReactComponent as UsdtTrc20Inner,
} from '../../images/icon-components/payment-types-logo/usdt-trc20.svg'

import {
  ReactComponent as Sbp,
  ReactComponent as SbpInner,
} from '../../images/icon-components/payment-types-logo/sbp.svg'

const config = {
  getuniq: {
    component: Getuniq,
    inner: GetuniqInner,
  },
  adsimple: {
    component: Adsimple,
    inner: Adsimple,
  },
  account: {
    component: Getuniq,
    inner: GetuniqInner,
  },
  user_balance: {
    component: Getuniq,
    inner: GetuniqInner,
  },
  qiwi_bank_card: {
    component: Card,
    inner: CardInner,
  },
  bank_card: {
    component: Card,
    inner: CardInner,
  },
  bank_card_cis: {
    component: Card,
    inner: CardInner,
  },
  bank_card_international: {
    component: Card,
    inner: CardInner,
  },
  paymaster_service: {
    component: Card,
    inner: CardInner,
  },
  qiwi_wallet: {
    component: Qiwi,
    inner: QiwiInner,
  },
  lucky: {
    component: Lucky,
    inner: LuckyInner,
  },
  cashless: {
    component: Cashless,
    inner: CashlessInner,
  },
  admitad: {
    component: Admitad,
    inner: AdmitadInner,
  },
  tinkoff: {
    component: Tinkoff,
    inner: TinkoffInner,
  },
  capitalist: {
    component: Capitalist,
    inner: CapitalistInner,
  },
  bitcoin: {
    component: Bitcoin,
    inner: BitcoinInner,
  },
  'usdt-erc20': {
    component: UsdtErc20,
    inner: UsdtErc20Inner,
  },
  'usdt-trc20': {
    component: UsdtTrc20,
    inner: UsdtTrc20Inner,
  },
  sbp: {
    component: Sbp,
    inner: SbpInner,
  },
}

export default config
